import React, { MouseEventHandler, useEffect } from "react";
import { docuwareLogo, docuwareLogoSmall } from "../../images";
import './Popup.scss'

type PopupDialogProps = {
    isVisible: boolean,
    content?: HTMLElement,
    buttons?: HTMLElement
    onClose: MouseEventHandler<HTMLDivElement>
}

const PopupDialog = (props: PopupDialogProps & {ref?: React.Ref<HTMLDivElement>}) => {
    useEffect(() => {
      props.isVisible ?
        document.getElementsByTagName("body")[0].style.overflowY = "hidden" :
        document.getElementsByTagName("body")[0].style.removeProperty("overflow-y")
    }, [props.isVisible])

    return (
        <div className={`popup-dialog ${props.isVisible ? 'visible' : ''}`}>
            <div className='dialog'>
                <div className="dialog-header">
                    <div className="dialog-header-container">
                        <div className='dw-logo'>
                            <img src={docuwareLogoSmall} className="dw-logo-icon-small" alt="dw-logo" height={40} />
                            <img src={docuwareLogo} className="dw-logo-icon" alt="dw-logo" height={40} />
                        </div>
                        <div className="action-icon-x" onClick={props.onClose}>
                        </div>
                    </div>
                </div>
                <div className='flex-wrapper'>
                    <div className='popup-dialog-content'>
                        {props.content}
                    </div>
                    <div className='button-container'>
                        {props.buttons}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PopupDialog;
